import { TextField, Button } from '@material-ui/core'
import React from 'react'
import { useFormik } from 'formik'
import axios from 'axios'

const EditBranch = props => {
    const formik = useFormik({
        initialValues: {
            name: props.name
        },
        onSubmit: values => {
            axios.put('accounts/branch/', {
                id: props.id,
                name: values.name
            }).then(result => {
                let newData = props.branchesState.map(branch => { return { id: branch.id, name: branch.name } })
                newData[newData.findIndex(branch => branch.id === props.id)].name = result.data.name
                props.setBranchesState(newData)
                props.setPopup(false)
            })
        }
    })
    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="name"
                label="نام شعبه"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                ویرایش
            </Button>
        </form>
    )
}

export default EditBranch